var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContactInfos)?_c('mission-detail-group-item',{staticClass:"mission-detail-contact-infos tw-w-full",attrs:{"title":_vm.$t('app.labels.address.contact_informations')}},[_vm._v(" "+_vm._s(_vm.contactInfos)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }